import { FeatureCollection } from 'geojson';
import { geojsonToGpx } from './geojsonToGpx';
import { getFeatureCollectionLineString } from './getFeatureCollectionLineString';

export interface ExportableRecording {
  lineString: string;
  timeStamps?: (string | number | null)[] | null;
  title?: string | null;
  createdAt?: string | null;
}

const DEFAULT_FILENAME = 'track';

/**
 * Builds the GPX file for "Export GPX" in My Recordings, named after the
 * recording's title and keeping each point's time.
 */
export function buildRecordingGpx(recording: ExportableRecording): { gpx: string; filename: string } {
  const geojson = JSON.parse(recording.lineString) as FeatureCollection;
  const coords = getFeatureCollectionLineString(geojson) ?? [];
  const title = recording.title?.trim() || undefined;

  const gpx = geojsonToGpx({
    type: 'Feature',
    properties: {},
    geometry: { type: 'LineString', coordinates: coords },
  }, recording.timeStamps, {
    creator: 'Hiiker',
    metadata: { name: title, time: recording.createdAt ?? undefined },
  });

  return { gpx, filename: `${title || DEFAULT_FILENAME}.gpx` };
}
